export const parseGroupRecordIds = (raw: string, resourceTypeIds: string): string[] => {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)) {
      const ids = new Set<string>();
      const typeIds = resourceTypeIds
        ? resourceTypeIds.split(",").map((id) => id.trim()).filter(Boolean)
        : [];
      typeIds.forEach((typeId) => {
        const arr = parsed[typeId];
        if (Array.isArray(arr)) {
          arr.forEach((id: string) => ids.add(id));
        }
      });
      return Array.from(ids);
    }
  } catch {
    // not JSON — return as-is
  }
  return raw.split(",").map((id: string) => id.trim());
};
